import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { MatIconRegistry } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent {
  constructor(matIconReg: MatIconRegistry) {
    matIconReg.setDefaultFontSetClass('material-symbols-outlined');
  }
}
